import request from 'lmcv/utils/axios'
import { API_ENDPOINTS } from 'lmcv/modules/endpoints'

export const getProfile = async () => {
  const response = await request
    .get(API_ENDPOINTS.profile)
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })

  return response
}

export const updateProfile = async data => {
  const response = await request
    .put(API_ENDPOINTS.profile, data)
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })

  return response
}

export const getProfileLoyalty = async () => {
  const response = await request
    .get(API_ENDPOINTS.profileLoyalty)
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })

  return response
}

export const getProfileBalance = async page => {
  const response = await request
    .get(API_ENDPOINTS.profileBalance, {
      params: { page, perPage: 6 }
    })
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })

  return response
}
